<template>
  <div class="form-group row">
    <label class="col-form-label col-lg-2">Addresses</label>
    <div class="col-lg-10">
      <div v-for="(address, index) in addresses" :key="index" class="mb-3 p-3 border rounded">
        <div class="row">
          <div class="col-md-6 form-group">
            <input
              type="text"
              class="form-control"
              placeholder="Address Line 1"
              v-model="address.addressLine1"
              @input="emitUpdate"
            >
          </div>
          <div class="col-md-6 form-group">
            <input
              type="text"
              class="form-control"
              placeholder="Address Line 2 (Optional)"
              v-model="address.addressLine2"
              @input="emitUpdate"
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 form-group">
            <input
              type="text"
              class="form-control"
              placeholder="City"
              v-model="address.city"
              @input="emitUpdate"
            >
          </div>
          <div class="col-md-6 form-group">
            <input
              type="text"
              class="form-control"
              placeholder="State / Province"
              v-model="address.state"
              @input="emitUpdate"
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 form-group">
            <input
              type="text"
              class="form-control"
              placeholder="Postal Code"
              v-model="address.postalCode"
              @input="emitUpdate"
            >
          </div>
          <div class="col-md-6 form-group">
            <select
              class="form-control"
              v-model="address.country"
              @change="emitUpdate"
            >
              <option
                v-for="country in countries"
                :key="country.value"
                :value="country.value"
              >
                {{ country.label }}
              </option>
            </select>
          </div>
          <div class="col-md-6 form-group">
            <select
              class="form-control"
              v-model="address.addressType"
              @change="emitUpdate"
            >
              <option
                v-for="type in addressTypes"
                :key="type"
                :value="type"
              >
                {{ type }}
              </option>
            </select>
          </div>
        </div>
        <div class="text-right" v-if="allowMultiple && addresses.length > 1">
          <button
            class="btn btn-sm btn-outline-danger"
            type="button"
            @click="removeAddress(index)"
          >
            <i class="fas fa-trash mr-1"></i> Remove Address
          </button>
        </div>
      </div>
      <div class="mt-2" v-if="allowMultiple && canAddMore">
        <a href="#" class="text-primary" @click.prevent="addAddress">
          <i class="fas fa-plus-circle mr-1"></i> Add another address
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressesSection',
  props: {
    value: {
      type: Array,
      required: true
    },
    countries: {
      type: Array,
      required: true
    },
    addressTypes: {
      type: Array,
      required: true
    },
    maxItems: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      addresses: []
    };
  },
  computed: {
    allowMultiple() {
      return this.maxItems === null || this.maxItems > 1;
    },
    canAddMore() {
      if (this.maxItems === null) return true;
      return this.addresses.length < this.maxItems;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.addresses = newVal;
      },
      deep: true
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('input', this.addresses);
    },
    addAddress() {
      this.addresses.push({
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        postalCode: "",
        country: "US",
        addressType: "RESIDENTIAL"
      });
      this.emitUpdate();
    },
    removeAddress(index) {
      this.addresses.splice(index, 1);
      this.emitUpdate();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ContactDetails/sections/AddressesSection.vue